import { makeStyles } from '@material-ui/core';

import { useCustomTheme } from '../../../hooks/useCustomTheme';

export const useEditableDataRowClasses = () => {
  const { palette, typography } = useCustomTheme();
  const styleDefinition = {
    root: {
      margin: '0px 4px 0px 0px',
      '& .MuiInputBase-input': {
        paddingBlock: '12px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
      '& .MuiSelect-root': { display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end' },
      '& .MuiInputBase-root': {
        alignItems: 'baseline',
      },
      '& .MuiInputBase-root.Mui-disabled': { color: 'inherit' },
      '& .MuiInput-underline.Mui-disabled:before': {
        borderBottomColor: 'none',
        borderBottom: `1px solid ${palette.grey[200]} !important`,
      },
      '& .MuiInput-underline:before': {
        borderBottom: `1px solid ${palette.grey[500]} !important`,
      },
      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomWidth: '1px',
      },
      '&.MuiButtonBase-root': {
        justifyContent: 'flex-end',
        fontSize: typography.subtitle2.fontSize,
        color: 'inherit',
      },
      '&.MuiFormControl-root': {
        margin: 0,
      },
      '& .MuiInputBase-multiline': {
        paddingBlock: 0,
      },
    },
  };
  const useStyles = makeStyles(styleDefinition);

  const classes = useStyles();

  return { classes, styleDefinition };
};
